import type { RouteRecordRaw } from 'vue-router'
import { RouteList } from '@/routes/RouteList'

const UnsubscribeView = () => import('@/views/Public/Unsubscribe/UnsubscribeView.vue')

export const unsubscribeRoutes: RouteRecordRaw[] = [
  {
    path: RouteList.PUBLIC.UNSUBSCRIBE.PATH,
    name: RouteList.PUBLIC.UNSUBSCRIBE.NAME,
    components: {
      default: UnsubscribeView,
    },
    meta: {
      requiresAuth: false,
    },
  },
]
